import { useState, useEffect, useCallback } from "react";
import { api } from "../api/api";

const useClientes = () => {
  const [clientes, setClientes] = useState([]);

  // Função auxiliar para ordenar a lista localmente
  const ordenarClientes = (lista) => {
    return [...lista].sort((a, b) => {
      const nomeA = (a.nomeCliente || a.nome || "").toLowerCase();
      const nomeB = (b.nomeCliente || b.nome || "").toLowerCase();
      return nomeA.localeCompare(nomeB, "pt-BR");
    });
  };

  // Envolvida com useCallback para estabilizar a referência da função
  const carregarClientes = useCallback(async () => {
    try {
      const response = await api.get("/clientes");
      setClientes(ordenarClientes(response.data));
    } catch (error) {
      console.error("Erro ao carregar clientes:", error);
    }
  }, []);

  // Agora carregarClientes pode ser incluído no array de dependências com segurança
  useEffect(() => {
    carregarClientes();
  }, [carregarClientes]);

  // 🔎 Buscar cliente por CPF ou nome (mantendo a ordem)
  const buscarCliente = (busca) => {
    const raw = (busca || "").trim();

    if (!raw) return clientes;

    const termoNome = raw.toLowerCase();
    const termoCpf = raw.replace(/\D/g, "");

    const isCpf = termoCpf.length === 11;

    const filtrados = clientes.filter((c) => {
      const nome = (c?.nome || c?.nomeCliente || "").toLowerCase();
      const cpf = (c?.cpf || "").replace(/\D/g, "");

      if (isCpf) {
        return cpf === termoCpf;
      }

      return nome.includes(termoNome);
    });

    return ordenarClientes(filtrados);
  };

  // 👤 Cadastrar cliente
  const cadastrarCliente = async (novoCliente) => {
    const response = await api.post("/clientes", novoCliente);
    const clienteCriado = response.data;

    // Adiciona e reordena a lista
    setClientes((prev) => ordenarClientes([...prev, clienteCriado]));

    return clienteCriado;
  };

  // ✏️ Sanitização e atualização do cliente
  const atualizarCliente = async (clienteAtualizado) => {
    try {
      const payload = { ...clienteAtualizado };

      if (payload.nome && !payload.nomeCliente) {
        payload.nomeCliente = payload.nome;
      }
      delete payload.nome;

      Object.keys(payload).forEach((key) => {
        if (payload[key] === "") {
          payload[key] = null;
        }
      });

      const response = await api.put(`/clientes/${payload._id}`, payload);
      const clienteSalvo = response.data;

      // Atualiza e mantém a lista reordenada (caso o nome tenha mudado)
      setClientes((prevClientes) => {
        const novaLista = prevClientes.map((c) =>
          c._id === clienteSalvo._id ? clienteSalvo : c
        );
        return ordenarClientes(novaLista);
      });

      return { success: true, data: clienteSalvo };
    } catch (error) {
      console.error("Erro ao atualizar cliente:", error?.response?.data || error);
      const mensagemErro =
        error?.response?.data?.erro || "Erro ao salvar as alterações no servidor.";
      alert(mensagemErro);
      return { success: false, error };
    }
  };

  return {
    clientes,
    buscarCliente,
    cadastrarCliente,
    atualizarCliente,
  };
};

export default useClientes;